var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsAtMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#ecac08",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.2034 14.3925c-1.801-.6778-2.4085-1.0871-2.4085-1.6227 0-.6259.571-.9702 1.6091-.9702.6533 0 1.2653.0903 1.8705.2753.3518.1085.7446.0668 1.0666-.1131.3233-.1815.5619-.491.6545-.8508l.0194-.0765c.1987-.7725-.2673-1.5668-1.0392-1.77122-.5299-.13937-1.1203-.23065-1.7575-.27034v-.62121c0-.69486-.5658-1.2604-1.2608-1.2604-.6954 0-1.2607.56554-1.2607 1.2604v.79973c-2.22.49777-3.5904 2.00244-3.5904 3.95974 0 2.4456 2.1235 3.4739 3.973 4.0963 1.5142.5117 2.1041.9718 2.1041 1.641 0 .6881-.6807 1.0986-1.8209 1.0986-.7686 0-1.5532-.1416-2.3331-.4202-.3472-.1244-.7434-.0959-1.0689.0765-.3294.1747-.571.4819-.6635.8416l-.0422.1668c-.1959.7628.2393 1.5484.9901 1.7894.7206.2308 1.5456.3838 2.345.4368v.7709c0 .6949.5659 1.2602 1.2603 1.2602.6954 0 1.2606-.5653 1.2606-1.2607v-.9444c2.3046-.4671 3.7829-2.0653 3.7829-4.1135-.0001-2.0156-1.1049-3.2661-3.6904-4.178z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsAtMs);
export default __webpack_public_path__ + "static/media/AmenitiesIconsATMs.4d0d7585da2246285ede5780e19e31e4.svg";
export { ForwardRef as ReactComponent };